import React from 'react';

export default function AnalyticsKpiCard({ label, value, subtitle }) {
  return (
    <div className="analytics-kpi-card">
      <span className="analytics-kpi-label">{label}</span>
      <span className="analytics-kpi-value">{value}</span>
      {subtitle && <span className="analytics-kpi-subtitle">{subtitle}</span>}
    </div>
  );
}

